(function () {
  const Core = window.RB.Core;

  window.RB.CardScripts = window.RB.CardScripts || {};
  Object.assign(window.RB.CardScripts, {
    "Highlander": {
      targets: [{ bind: "t", spec: { type: "unit", friendly: true }, prompt: "Which unit is recalled instead of dying this turn?" }],
      play: [{ op: "deathReplaceRecall", to: "$t" }],
    },

    "Yi, Meditative": {
      selfMightSpecs: [{ n: 4, cond: { k: "runesAtLeast", n: 8 } }],
    },

    "Wuju Bladesman - Starter": {
      auraMightSpecs: [{ n: 2, targetCond: { k: "and", conds: [{ k: "defending" }, { k: "aloneHere" }] } }],
    },

    "Zephyr Sage": {},
  });
})();
